import React, { useRef } from 'react';
import TooltipStyled from '../../skeleton/tooltipStyled/TooltipStyled';
export default function OverflowTip({ children, fontSize = 15, title = '' }) {
    const textElementRef = useRef(null);
    return (React.createElement(TooltipStyled, { title: title || children, content: React.createElement("div", { className: "overflow-container", ref: textElementRef, style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: `${fontSize}px`,
                lineHeight: `${fontSize + 4}px`,
            } },
            React.createElement("span", null, children)) }));
}
